export { default as AdCard } from './AdCard';



// WEBPACK FOOTER //
// ./src/components/AdCard/index.ts